import { createRouter, createWebHashHistory } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout';
import Login from '@/views/authentication/Login.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: 'Login' }
  },
  {
    path: '/account-recovery',
    name: 'Account recovery',
    component: () => import('@/views/authentication/AccountRecovery.vue'),
    meta: { title: 'Account Recovery' }
  },
  {
    path: '/account-recovery',
    name: 'Account recovery',
    component: () => import('@/views/authentication/AccountRecovery.vue'),
    meta: { title: 'Account Recovery' }
  },
  {
    path: '/account-recovery',
    name: 'Account recovery',
    component: () => import('@/views/authentication/AccountRecovery.vue'),
    meta: { title: 'Account Recovery' }
  },
  {
    path: '/',
    name: 'Exam Checker',
    component: DefaultLayout,
    redirect: '/exam-checker',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/exam-checker',
        name: 'Home',
        component: () => import('@/views/ExamChecker.vue'),
        meta: { requiresAuth: true, title: 'Exam Checker' },
      },
      {
        path: '/context',
        name: 'Context',
        component: () => import('@/views/context/ContextList.vue'),
        meta: { requiresAuth: true, title: 'Context' },
      },
      {
        path: '/context/create',
        name: 'Create context',
        component: () => import('@/views/context/ContextCreate.vue'),
        meta: { requiresAuth: true, title: 'Context Create' },
      },
      {
        path: '/context/:id',
        name: 'Context details',
        component: () => import('@/views/context/ContextDetails.vue'),
        meta: { requiresAuth: true, title: 'Context Details' },
        props: true,
      },
      {
        path: '/user',
        name: 'User',
        component: () => import('@/views/user/UserLists.vue'),
        meta: { requiresAuth: true, title: 'User' },
      },
      {
        path: '/user/create',
        name: 'Create user',
        component: () => import('@/views/user/UserCreate.vue'),
        meta: { requiresAuth: true, title: 'User Create' }
      },
      {
        path: '/user/:id',
        name: 'User details',
        component: () => import('@/views/user/UserDetails.vue'),
        meta: { requiresAuth: true, title: 'User Details' },
        props: true,
      },
      {
        path: '/exam-types',
        name: 'Exam Type',
        component: () => import('@/views/exam-types/ExamTypeList.vue'),
        meta: { requiresAuth: true, title: 'Exam Type' },
      },
      {
        path: '/exam-types/create',
        name: 'Create exam type',
        component: () => import('@/views/exam-types/ExamTypeCreate.vue'),
        meta: { requiresAuth: true, title: 'Exam Type Create' },
      },
      {
        path: '/exam-types/:id',
        name: 'Exam type details',
        component: () => import('@/views/exam-types/ExamTypeDetails.vue'),
        meta: { requiresAuth: true, title: 'Exam Type Details' },
        props: true,
      },
      {
        path: '/change-password',
        name: 'Change Password',
        component: () => import('@/views/ChangePassword.vue'),
        meta: { requiresAuth: true, title: 'Change Password' },
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { requiresAuth: true, title: 'Dashboard' },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem('token');

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login');
  } else {
    next();
  }
});

export default router;
